import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function GovernmentIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M3 10.7231V18.5039H5V11H7V18.5039H9V11H15V18.5039H17V11H19V18.5039H21V10.723C21.6904 10.4058 22.2486 9.83276 22.54 9.08691L23.124 7.58007L12 0.830078L0.875977 7.58008L1.46094 9.08789C1.75171 9.83301 2.30969 10.4058 3 10.7231ZM12 3.16992L20.6514 8.41894C20.4883 8.76855 20.1309 8.99999 19.7432 8.99999H4.25684C3.86231 8.99999 3.51172 8.77343 3.34864 8.41894L12 3.16992ZM13.6 20H23V22H0.999997V20H10.4V16.6C10.4 15.7163 11.1163 15 12 15C12.8837 15 13.6 15.7163 13.6 16.6V20Z",
    fill: "currentColor"
  }));
}